<template>

<div class="pie" :class="{'is-dark': dark}">

	<div class="pie-slice is-front" :style="{background: 'conic-gradient(#b4d5f5 0deg ' + percent + '%, transparent ' + percent + '% 100%)'}"></div>
	<div class="pie-slice is-back" :style="{background: 'conic-gradient(transparent 0deg ' + percent + '%, #4881bb ' + percent + '% 100%)'}"></div>

</div>

</template>

<script>

export default {

	props: ['values', 'dark'],

	computed: {

        percent: function() {

            return Math.round((100 / (this.values[0] + this.values[1])) * this.values[1])

        }

    }

}

</script>

<style scoped>

.pie {
    width: 64px;
    height: 64px;
}

.pie-slice {
    width: 64px;
    height: 64px;
    background-color: #4881bb;
    z-index: 1;
    position: absolute;
    aspect-ratio: 1;
    border-radius: 50%;
}

.pie-slice.is-front {
    z-index: 2;
}

.pie-slice.is-back {
    z-index: 2;
}

</style>
